import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RegistrationFormManager.html?raw';
import on from 'dojo/on';
import "../../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload";
import "../../../../moreCore/UI/CheckBox/CheckBox";
import RegistrationForm from '../RegistrationForm/RegistrationForm';
import domConstruct from 'dojo/dom-construct';

class RegistrationFormManager extends compose(_WidgetBaseSP) {
    templateString: any = template;

    regForm: MdsLax<InstanceType<typeof RegistrationForm>> = null;

    registrationFormContainer: HTMLDivElement;
    saveButton: HTMLButtonElement;

    startRegistrationForm(hasRole: boolean): void {

        let registerNode = document.getElementById("doctorlist_registerlink");
        if (!hasRole) {

            if (registerNode) {
                this.UiModder.domClass.remove(registerNode, "w3-hide");
            }
            return;
        }

        if (registerNode) {
            this.UiModder.domClass.add(registerNode, "w3-hide");
        }

        var form = new RegistrationForm();
        form.startup();

        this.UiModder.domClass.remove(this.domNode, "w3-hide");

        this.regForm = form;

        //form.finished = resetHitched;
        domConstruct.empty(this.registrationFormContainer);
        form.placeAt(this.registrationFormContainer);

        form.useOwnSaveButton(true);

        on(form, "isDirty", lang.hitch(this, this.showSaveButton, form));

        let requestUrl = window.appRoot + "doctorlist/GetDoctorInfo";

        this.StandbyStart(this.registrationFormContainer);

        //this.setUrlParameter(DoctorList_UrlParameters.action, "editMe");

        this.RequestManager.post(
            requestUrl,
            {},
            lang.hitch(this, this._onGetData),
            lang.hitch(this, this._onGetDataError),
            false // sync
        );
    }

    private dirtyState: boolean = false;

    showSaveButton(form: MdsLax<InstanceType<typeof RegistrationForm>>, state: boolean) {
    //    if (state === true) {
    //        this.UiModder.domClass.remove(this.saveButton, "w3-disabled");
    //    } else {
    //        this.UiModder.domClass.add(this.saveButton, "w3-disabled");
    //    }

    //    this.dirtyState = state === true;
    }

    _onClick_Save(evt: MouseEvent) {

        if (this.dirtyState !== true) {
            return;
        }

        if (this.regForm) {
            this.regForm.saveEdit();
        }
    }

    _onGetData(response: DoctorList.DoctorData): void {
        this.regForm.setData(response, false, "showButton");
        this.StandbyStop();
    }

    _onGetDataError(error: more.requestErrorMessage): void {
        this.StandbyStop();
        alert("could not load registration data:\r\n" + error.Message)
    }

    _onCloseSession(): void {
        if (this.regForm) {
            this.regForm.destroy();
        }
        this.regForm = null;
        this.UiModder.domClass.add(this.domNode, "w3-hide");
    }

    _onOpenSession(): void {
        //this.hasUserRole("DOC", lang.hitch(this, this.startRegistrationForm));
        this.startup();
    }

    _setupSubscriptions(): void {
        super._setupSubscriptions.apply(this, arguments as any);

        this.addSubscription("/Session/Close", lang.hitch(this, this._onCloseSession));        
        this.addSubscription("/Session/Open", lang.hitch(this, this._onOpenSession));        
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        let registerNode = document.getElementById("doctorlist_registerlink");
        if (registerNode) {
            this.UiModder.domClass.remove(registerNode, "w3-hide");
        }
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.hasUserRole("DOC", lang.hitch(this, this.startRegistrationForm));

        
        
    }
    
}

export default mdsWidget(RegistrationFormManager);